// src/components/Services/EmailDevelopmentServices.js
import React from 'react';
import './EmailDevelopmentServices.css';

const EmailDevelopmentServices = () => {
  const services = [
    {
      title: 'Custom Email Template Design',
      description:
        'I design and develop custom HTML email templates that are responsive and visually appealing. My templates ensure consistent rendering across email clients, perfect for newsletters and marketing campaigns.',
      icon: '📧', // Email icon
    },
    {
      title: 'AMPScript Email Development',
      description:
        'I specialize in AMPScript to create dynamic, personalized email campaigns. From conditional content to data-driven personalization, I help you engage your audience with targeted email solutions.',
      icon: '💻', // Computer icon
    },
    {
      title: 'Email Campaign Optimization',
      description:
        'I optimize email campaigns for deliverability, engagement, and conversions. My services include A/B testing, responsive design, and ensuring compatibility with major email clients like Gmail and Outlook.',
      icon: '📈', // Chart icon
    },
  ];

  return (
    <div className="emaildev-services">
      <h2 className="emaildev-services-title">Email Development Services</h2>
      <div className="emaildev-services-grid">
        {services.map((service, index) => (
          <div key={index} className="emaildev-service-card">
            <div className="emaildev-service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailDevelopmentServices;